import React, { FC, PropsWithChildren } from "react";

import { Helmet } from "react-helmet-async";
import { useTranslation } from "react-i18next";

import { UrlManager } from "@/shared/apis/UrlManager";
import { useRouterHook } from "@/shared/hooks";

import NotAuthenticatedHeader from "./components/NotAuthenticatedHeader/NotAuthenticatedHeader";
import {
    StyledNotAuthBottom,
    StyledNotAuthContainer,
    StyledNotAuthContainerLeft,
    StyledNotAuthContainerLeftSide,
    StyledNotAuthContainerRight,
    StyledNotAuthMain,
    StyledNotAuthPanel,
    StyledNotAuthPanelContainer,
    StyledNotAuthPanelContainerForm,
    StyledNotAuthSection,
    StyledNotAuthSteps,
    StyledNotAuthTitle,
    StyledNotAuthWrapper,
} from "./styled";

type NotAuthenticatedFormLayoutProps = {
    flowStepsComponent: React.ReactElement;
    title?: string;
    officeId?: string;
};
const NotAuthenticatedFormLayout: FC<PropsWithChildren<NotAuthenticatedFormLayoutProps>> = ({
    flowStepsComponent,
    children,
    title,
    officeId,
}) => {
    const { t } = useTranslation();

    const {
        globalState: { officeId: officeIdState },
    } = useRouterHook();

    const officeIdForStylesheet = officeId || officeIdState;

    return (
        <StyledNotAuthMain>
            <Helmet>
                <title>{`MyBroker - ${title}`}</title>
                <body data-custom-theme={officeIdForStylesheet} />
                {officeIdForStylesheet && (
                    <link rel="stylesheet" href={UrlManager.brokerSchema(officeIdForStylesheet)} />
                )}
            </Helmet>
            <NotAuthenticatedHeader lightMenu lightMenuSmallInverted />
            <StyledNotAuthContainer>
                <StyledNotAuthContainerLeftSide />
                <StyledNotAuthContainerLeft>
                    <StyledNotAuthSection>
                        <StyledNotAuthSteps>{flowStepsComponent}</StyledNotAuthSteps>
                        <StyledNotAuthPanel>
                            <StyledNotAuthPanelContainer>
                                <StyledNotAuthPanelContainerForm>{children}</StyledNotAuthPanelContainerForm>
                            </StyledNotAuthPanelContainer>
                        </StyledNotAuthPanel>
                    </StyledNotAuthSection>
                </StyledNotAuthContainerLeft>
                <StyledNotAuthContainerRight>
                    <StyledNotAuthWrapper>
                        <StyledNotAuthTitle>{t("Registration.WelcomeMessage")}</StyledNotAuthTitle>
                        <StyledNotAuthBottom></StyledNotAuthBottom>
                    </StyledNotAuthWrapper>
                </StyledNotAuthContainerRight>
            </StyledNotAuthContainer>
        </StyledNotAuthMain>
    );
};

export default NotAuthenticatedFormLayout;
